<ng-container *ngIf="!itemPage">
  <nb-icon class="catalog-show__icon" [hidden]="isOpened"
           i18n-title="@@ToggleTree"
           title="{{ isOpened ? 'скрыть дерево':'показать дерево' }}" (click)="toggleOpened()"
           icon="menu-arrow-outline"></nb-icon>

  <div class="resizable" [style.width]="width + 'px'" resizable (onResize)="onResize($event)" [ngClass]="isOpened ? '':'hidden-center'">
    <div class="flex-item" [ngClass]="isOpened ? '':'hidden-center'">
      <nb-card [hidden]="!isOpened">
        <nb-card-header class="icon__catalog-tree">
          <nb-action>
            <app-choose-catalog-input (catalogChosenEvent)="onCatalogSelected($event)"
                                      [onlyOneSelection]="true"
                                      [chooseOnlyLastLevel]="false"
                                      header=""
            ></app-choose-catalog-input>
          </nb-action>
          <nb-action (click)="toggleDeleted()" i18n-nbTooltip="@@ShowDeleted" nbTooltip="Показать неактивные"
                     [icon]="showDeleted ? 'eye' : 'eye-outline'"></nb-action>
          <nb-action (click)="reindex()" i18n-nbTooltip="@@ElasticReindexCatalog"
                     [disabled]="reindexing"
                     *nbIsGranted="['reindex', 'catalog_tree']"
                     nbTooltip="Переиндексировать структуру каталогов"
                     icon="refresh-outline">
          </nb-action>
          <nb-action (click)="exportCatalogStructure()"
                     i18n-nbTooltip="@@ExportXlsx"
                     nbTooltip="Экспорт структуры каталога в Excel"
                     icon="download-outline">
          </nb-action>
          <nb-action (click)="toggleOpened()" i18n-nbTooltip="@@HideTree"
                     icon="menu-arrow-outline"
                     nbTooltip="Скрыть дерево">
          </nb-action>
          <nb-action [routerLink]="'create'" i18n-nbTooltip="@@AddRootCategory"
                     nbTooltip="Добавить корневой раздел"
                     icon="plus-outline">
          </nb-action>
        </nb-card-header>

        <nb-card-body class="switch" style="overflow: visible">

          <app-compo-tree [treeData]="data1">
            <ng-template let-item>
              <div class="tree-item-wrapper" [ngClass]="{deletedCatalog: item.deleted === true, disabledCatalog: item.enabled === false, 'tree-node-selected': item.id==catalogId}">
                <div class="tree-item" (click)="setId(item.id, true)" title="{{ item.header }}">
                  <span>{{ item.header }}</span>
                </div>

                <span class="product-count" *ngIf="item.productCount > 0 || item.productCountAdditional > 0" i18n-nbTooltip="@@ProductCount" [nbTooltip]="'Количество товаров в категории' + (item.productCountAdditional > 0 ? ' и из дополнительной категории' : '')">
                  {{ item.productCount?.toLocaleString() || 0 }}
                  <span *ngIf="item.productCountAdditional > 0">{{ "/ " + (item.productCountAdditional?.toLocaleString() || 0) }}</span>
                </span>
                <ng-container *ngTemplateOutlet="ActionButtons; context: {id: item.id, enabled: item.enabled, deleted: item.deleted}"></ng-container>
                <span class="expand-collapse" *ngIf="(!item.lastLevel)" (click)="setId(item.id, true)"><nb-icon [icon]="!item.expanded ? 'chevron-down-outline':'chevron-up-outline'"></nb-icon></span>
                <span class="expand-collapse expand-collapse-fake" *ngIf="(item.lastLevel)"></span>
              </div>
            </ng-template>
          </app-compo-tree>

          <ng-template #ActionButtons let-lastLevel="lastLevel" let-id="id" let-enabled="enabled" let-deleted="deleted">
            <button nbButton status="control" [matMenuTriggerFor]="menu">
              <nb-icon icon="more-vertical-outline"/>
            </button>
            <mat-menu #menu="matMenu">
              <div>
                <button mat-menu-item [routerLink]="['edit',id]" i18n="@@Edit">
                  <nb-icon icon="edit-outline"></nb-icon>
                  Редактировать
                </button>

                <button mat-menu-item i18n="@@SearchSettings" [routerLink]="[id,'ranging']"
                        (click)="setId(id, false)">
                  <nb-icon icon="search-outline"></nb-icon>
                  Настройка поиска
                </button>
                <button *ngIf="lastLevel !== true && enabled === true && deleted === false" mat-menu-item
                        [routerLink]="['create', id]"
                        i18n="@@AddSubCategory">
                  <nb-icon icon="plus-outline"></nb-icon>
                  Добавить подраздел
                </button>
                <button mat-menu-item (click)="onDeleteConfirm(id)" i18n="@@Delete">
                  <nb-icon icon="close-outline"></nb-icon>
                  Удалить
                </button>
              </div>
            </mat-menu>
          </ng-template>

        </nb-card-body>
      </nb-card>
    </div>
    <div class="grabber" grabber></div>
  </div>
</ng-container>
<div class="flex-item__right" style="flex: 1 1 auto;" [ngClass]="isOpened ? '':'fixed-center'">
  <router-outlet></router-outlet>
</div>
